export const MAX_VISIBLE_COMPANIES = 4;
export const EXPORT_MAX_VISIBLE_COMPANIES = 4;
export const LEGEND_WIDTH_FRACTION = 0.2;
export const MIN_LEGEND_WIDTH = 250;
export const CHART_LEGEND_WIDTH = 80;
export const ARROW_WIDTH = 50;
